import React from 'react';
import { CheckIcon, ShieldCheckIcon, LockIcon, DownloadIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FinalOffer() {
  const items = ['Kit "Crecer Jugando" completo (+100 actividades)', 'Bono 1 — Las Primeras Palabras', 'Bono 2 — Números y Grafomotricidad', 'Bono 3 — Observación y Coordinación', 'Bono 4 — Guía Práctica para Padres', 'Bono 5 — Planificador Imprimible', 'Acceso inmediato por email', 'Compatible con celular, tablet y PC'];
  return <section className="bg-brand-green-50/40 px-5 py-10 sm:py-12" data-id="element-67">
      <div className="max-w-xl mx-auto" data-id="element-68">
        <div className="text-center mb-8" data-id="element-69">
          <p className="text-xs uppercase tracking-wider text-brand-green-600 font-bold mb-3" data-id="element-70">
            Oferta de hoy
          </p>
          <h2 className="font-extrabold text-3xl sm:text-4xl text-brand-ink leading-tight tracking-tight" data-id="element-71">
            Empezá hoy mismo
          </h2>
          <p className="mt-3 text-slate-600" data-id="element-72">
            Recibís el kit completo + los 5 bonos por un único pago.
          </p>
        </div>

        <div className="bg-white rounded-3xl border border-slate-100 shadow-soft-lg p-6 sm:p-8" data-id="element-73">
          {/* Whats included */}
          <ul className="space-y-3 mb-6" data-id="element-74">
            {items.map(item => <li key={item} className="flex items-start gap-3 text-slate-700" data-id="element-75">
                <span className="w-5 h-5 rounded-full bg-brand-green-100 flex items-center justify-center shrink-0 mt-0.5" data-id="element-76">
                  <CheckIcon className="w-3 h-3 text-brand-green-700" strokeWidth={3} data-id="element-77" />
                </span>
                <span className="text-sm leading-snug" data-id="element-78">{item}</span>
              </li>)}
          </ul>

          {/* Price */}
          <div className="bg-brand-green-50/60 rounded-2xl p-5 text-center border border-brand-green-100" data-id="element-79">
            <div className="flex items-baseline justify-center gap-2 mb-1" data-id="element-80">
              <span className="text-sm text-slate-400 line-through" data-id="element-81">
                $49.990
              </span>
              <span className="text-xs font-bold text-brand-green-700 bg-white px-2 py-0.5 rounded-full" data-id="element-82">
                60% OFF
              </span>
            </div>
            <div className="font-extrabold text-4xl sm:text-5xl text-brand-ink tracking-tight" data-id="element-83">
              $19.990{' '}
              <span className="text-base font-semibold text-slate-500" data-id="element-84">
                ARS
              </span>
            </div>
            <p className="text-xs text-slate-500 mt-1" data-id="element-85">
              Pago único · sin suscripción
            </p>
          </div>

          {/* CTA */}
          <div className="mt-6" data-id="element-86">
            <CTAButton text="Quiero acceder ahora" data-id="element-87" />
          </div>

          {/* Trust badges */}
          <div className="mt-6 grid grid-cols-3 gap-3 text-center" data-id="element-88">
            <div className="flex flex-col items-center gap-1" data-id="element-89">
              <LockIcon className="w-4 h-4 text-slate-400" data-id="element-90" />
              <span className="text-[11px] text-slate-500 font-medium" data-id="element-91">
                Pago seguro
              </span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-92">
              <DownloadIcon className="w-4 h-4 text-slate-400" data-id="element-93" />
              <span className="text-[11px] text-slate-500 font-medium" data-id="element-94">
                Acceso inmediato
              </span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-95">
              <ShieldCheckIcon className="w-4 h-4 text-slate-400" data-id="element-96" />
              <span className="text-[11px] text-slate-500 font-medium" data-id="element-97">
                Garantía 7 días
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}